export class AgentFilter{
    SearchName: string;
    SortBy: string;
    PageIndex: number;
    PageSize: number;
    SOrtDirection: string;
}
